import { atom, useSetAtom } from 'jotai'
import { useCallback } from 'react'

/** True while the session-expired dialog waits for the user to sign in again. */
export const sessionExpiredAtom = atom(false)

let sessionExpired = false

/** Outside-React read of `sessionExpiredAtom`, for request gating. */
export const isSessionExpired = () => sessionExpired

/**
 * Sets `sessionExpiredAtom` and its outside-React copy together, so the
 * dialog and the request block always agree.
 */
export const useSetSessionExpired = () => {
  const setSessionExpiredAtom = useSetAtom(sessionExpiredAtom)
  return useCallback(
    (expired: boolean) => {
      sessionExpired = expired
      setSessionExpiredAtom(expired)
    },
    [setSessionExpiredAtom],
  )
}

let mountedSessionExpiredDialogs = 0

/**
 * Registers a mounted session-expired dialog. While one is mounted, a failed
 * token refresh shows it instead of logging out and reloading immediately.
 *
 * @returns an unregister function for effect cleanup.
 */
export const registerSessionExpiredDialog = () => {
  mountedSessionExpiredDialogs += 1
  return () => {
    mountedSessionExpiredDialogs -= 1
  }
}

export const isSessionExpiredDialogMounted = () =>
  mountedSessionExpiredDialogs > 0
